import { toast } from 'sonner'
import { useSetSourceCategories, useSourcingCategories } from '@/api/sourcing'
import { SourcingCategoryPicker } from '@/components/sourcing-category-picker'
import { formatApiErrorMessage } from '@/lib/api-error'

/**
 * Which store categories a backup source takes new POs for (USA-1506): a PO goes to it when
 * everything on the PO is in these categories, e.g. a brand's parts ordered without equipment.
 */
export function SourceCategoriesField({
  manufacturerUuid,
  optionId,
}: {
  manufacturerUuid: string
  optionId: number
}) {
  const categories = useSourcingCategories(manufacturerUuid)
  const setCategories = useSetSourceCategories(manufacturerUuid)
  const value =
    setCategories.isPending && setCategories.variables?.optionId === optionId
      ? setCategories.variables.taxonomyNodeIds
      : (categories.data?.sources.find((source) => source.sourcing_option_id === optionId)
          ?.taxonomy_node_ids ?? [])

  return (
    <div className="space-y-1.5">
      <SourcingCategoryPicker
        categories={categories.data?.categories ?? []}
        value={value}
        disabled={categories.isLoading}
        onChange={(taxonomyNodeIds) =>
          setCategories.mutate(
            { optionId, taxonomyNodeIds },
            {
              onError: (error) =>
                toast.error(formatApiErrorMessage('Categories not saved', error)),
            },
          )
        }
      />
      <p className="text-xs text-muted-foreground">
        {value.length
          ? 'New POs come here when everything on them is in these categories.'
          : 'Only when chosen on a PO. Add categories to send POs of only those products here.'}
      </p>
    </div>
  )
}
